const i18nKeyPrefix = 'symbol.details.indicators.fundamentalAnalysis.';

export const INDICATORS = {
  netSales: { 
    name: `${i18nKeyPrefix}netSales`,
    precision: 0,
    suffix: null
  },
  netSalesChange: { 
    name: `${i18nKeyPrefix}netSalesChange`,
    precision: 2,
    suffix: '%'
  },
  ordinaryProfit: { 
    name: `${i18nKeyPrefix}ordinaryProfit`,
    precision: 0,
    suffix: null
  },
  ordinaryProfitChange: { 
    name: `${i18nKeyPrefix}ordinaryProfitChange`,
    precision: 2,
    suffix: '%'
  },
  netProfit: { 
    name: `${i18nKeyPrefix}netProfit`,
    precision: 0,
    suffix: null
  },
  netProfitChange: { 
    name: `${i18nKeyPrefix}netProfitChange`,
    precision: 2,
    suffix: '%'
  },
  earningsPerShare: { 
    name: `${i18nKeyPrefix}earningsPerShare`,
    precision: 2,
    suffix: null
  },
  priceEarningsRatio: { 
    name: `${i18nKeyPrefix}priceEarningsRatio`,
    precision: 2,
    suffix: `${i18nKeyPrefix}times`
  },
  priceBookRatio: { 
    name: `${i18nKeyPrefix}priceBookRatio`,
    precision: 2,
    suffix: `${i18nKeyPrefix}times`,
    hideForecast: true
  },
  returnOnEquity: { 
    name: `${i18nKeyPrefix}returnOnAverageEquity`,
    precision: 2,
    suffix: '%',
    hideForecast: true
  },
  returnOnAssets: { 
    name: `${i18nKeyPrefix}returnOnAverageAssets`,
    precision: 2,
    suffix: '%',
    hideForecast: true
  },
  bookValuePerShare: { 
    name: `${i18nKeyPrefix}bookValuePerShare`,
    precision: 2,
    suffix: null,
    hideForecast: true
  },
  capitalAdequacyRatio: { 
    name: `${i18nKeyPrefix}capitalAdequacyRatio`,
    precision: 2,
    suffix: '%',
    hideForecast: true
  }
};
